import { Styles } from 'react-jss'
import colors from 'lib/colors'
import { cssVarColors, cssVarTextColors } from 'lib/cssSelector'
const { white } = cssVarTextColors
const { main } = cssVarColors

export const sheet: Styles = {
  base: {
    all: 'unset',
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: '0%',
    textDecoration: 'unset',
    fontFamily: 'Poppins',

    display: 'flex',
    alignItems: 'center'
  },

  fill: {
    width: '-webkit-fill-available',
    justifyContent: 'center'
  },

  // size
  sm: {
    height: '32px',
    fontSize: '12px',
    gap: '4px',
    padding: '0 20px',
    borderRadius: '16px'
  },
  md: {
    borderRadius: '20px',
    height: '40px',
    fontSize: '16px',
    gap: '6px',
    padding: '0 24px'
  },
  lg: {
    borderRadius: '24px',
    height: '48px',
    fontSize: '16px',
    gap: '8px',
    padding: '0 24px'
  },
  roundedSquere: {
    borderRadius: '8px'
  },

  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
    userSelect: 'none'
  }
}
